import React from 'react'
import { Link, Outlet } from "react-router-dom";
import "../Styles/UploadPage.css"

function UploadPage() {
  return (
    <div className="upload">
      <h1>Create your own Timelapse!</h1>
      <h2>You can create your own timelapse by requesting your data from BeReal and uploading it here.</h2>
      <p>Have you already received your data?</p>
        <div className="uploadNav">
            <Link to="/upload/u1"> 
              <button >How do I get my data?</button>
            </Link>
            <Link to="/upload/u2"> 
              <button>Yes, create my timelapse!</button>
            </Link>
        </div>
        <Outlet />
    </div>

  )
}

export default UploadPage